import { Outlet, } from 'react-router-dom';
import { Box, } from '@mui/material';
import { AppbarContextProvider, } from '../../hoc/context/AppbarContext';
import CustomContainer from '../custom-container';
import Header from '../header';
import Footer from '../footer';

const Layout = () => {
    return (
        <Box sx={{ display: 'flex',  flexDirection: 'column', height: '100vh', }}>
            <AppbarContextProvider>
                <Header />
            </AppbarContextProvider>
            <Box component='main' sx={{ flexGrow: 1, mt: [7, 8], pt: [3, 4, 5, 6], pb: [5, 6, 7, 8], }}>
                <CustomContainer>
                    <Outlet />
                </CustomContainer>
            </Box>
            <Footer />
        </Box>
    );
};

export default Layout;
